<template>
  <div>
    <notify />
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </div>
</template>

<script>
import Meta from '@/mixins/meta'
import { waitForReadyState } from '@/utils'
import { call } from 'vuex-pathify'
import Notify from '@components/Notify'

export default {
  name: 'App',
  components: { Notify },
  mixins: [Meta],
  watch: {
    '$route.path'() {
      typeof window !== 'undefined' && window.scrollTo(0, 0)
      const routeName = this.$route.name || null
      if (routeName) {
        this.setBreadcrumb(routeName)
      }
      this.hideAlert()
    }
  },
  created() {
    const routeName = this.$route.name || null
    if (routeName) {
      this.setBreadcrumb(routeName)
    }
  },
  async mounted() {
    await this.$nextTick()
    await waitForReadyState()
  },
  methods: {
    setBreadcrumb: call('breadcrumb/set'),
    hideAlert: call('alert/hide')
  }
}
</script>

<style lang="sass">
.body-dark
  background-color: #000 !important
.body-light
  background-color: rgba(240,248,255, .5) !important
.text-decoration-none
  text-decoration: none
.wf-loading .material-icons
  display: none
.v-application .markdown code
  box-shadow: none
  color: #c0341d
  background-color: #fbe5e1
.v-application .markdown kbd > code
  background: transparent
  color: inherit
.theme--light.v-application
  background: rgba(240,248,255, .5) !important
.v-application a
  text-decoration: none
.theme--light.v-app-bar.v-toolbar.v-sheet
  background-color: rgba(240,248,255, 1) !important
.theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled
  color: rgba(0, 0, 0, 1) !important
.v-breadcrumbs .v-breadcrumbs__item
  font-weight: 600 !important
</style>
